<rx-intuitive-teeth-diagram-layout>
	<div class="rx-intuitive-teeth-diagram__chart-toolbar" rx-intuitive-teeth-diagram-toolbar>
		<rx-copy-from-tooth-menu
			*ngIf="showCopyFromMenu$ | async"
			class="rx-intuitive-teeth-diagram__copy-from-menu"
			id="rx-intuitive-copy-from-tooth"
			[disabled]="isCopyFromToothControlDisabled$ | async"
			[sourceMenuItems]="(copyFromSourceMenuItems$ | async) ?? []"
			[defaultIndicationId]="copyFromMenuDefaultIndicationId"
			(sourceSelected)="onCopyFromToothSourceSelected($event)"
		/>
	</div>
	<rx-intuitive-teeth-diagram
		rx-intuitive-teeth-diagram-diagram
		[upperJaw]="(upperJaw$ | async) ?? []"
		[lowerJaw]="(lowerJaw$ | async) ?? []"
		[chartReadOnly]="chartReadOnly$ | async"
		(toothClicked)="onToothClicked($event)"
		(resetSelectedRequested)="onResetSelectedRequested()"
	></rx-intuitive-teeth-diagram>

	<rx-intuitive-indication-buttons
		rx-intuitive-teeth-diagram-buttons
		[attr.data-bi-attr-selected-tooth-count]="(selectedToothIds$ | async)?.length || '0'"
		[indicationIds]="(indications$ | async) ?? []"
		[enabledIndicationIds]="(enabledIndications$ | async) ?? []"
		[selectedIndicationIds]="(selectedTeethIndicationIds$ | async) ?? []"
		[disabled]="indicationButtonsDisabled$ | async"
		[asLabel]="indicationButtonsAsLabel$ | async"
		(indicationSelected)="onIndicationSelected($event)"
	></rx-intuitive-indication-buttons>

	<div rx-intuitive-teeth-diagram-panel>
		<rx-intuitive-teeth-treatment-viewlist
			*ngIf="showTreatmentViewList$ | async"
			[treatmentListItems]="(previewTreatmentListItems$ | async) ?? []"
			(clicked)="onOpenTreatmentEditorFromList($event)"
		/>
		<rx-intuitive-tooth-editor
			*ngIf="isToothEditorShown$ | async"
			[teeth]="(editorTeeth$ | async) ?? []"
			[canEdit]="(canEditToothEditor$ | async) ?? true"
			[canDelete]="(canDeleteToothEditor$ | async) ?? true"
			(delete)="clearSelection()"
			(crownFormChanged)="onToothCrownFormChanged($event)"
			(additionalInfoApplied)="onToothAdditionalInfoApplied($event)"
			(clearDisabledFields)="onToothClearDisabledFields($event)"
		/>
		<div class="rx-intuitive-teeth-diagram__no-editor" *ngIf="showSidePanelPlaceholder$ | async">
			{{ 'TeethDiagram.SelectTeethToStart' | translate }}
		</div>
	</div>

	<rx-intuitive-teeth-diagram-footer
		rx-intuitive-teeth-diagram-footer
		[showBackButton]="showPanelBack$ | async"
		(back)="focusDiagram()"
	/>

</rx-intuitive-teeth-diagram-layout>
